<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import io from 'socket.io-client';
import store from '@/store/state'
import { Toast } from 'vant'
import Vue from 'vue'
import api from '@/http/api'
let socket
export default {
  name: "App",
  provide() {
    return {
      initSocket: this.init,
      url: ''
    }
  },
  components: {
    [Toast.name]: Toast
  },
  created() {
    this.url = store.envConfigs[(process.env.ENV_CONFIG || "stageQqs")].customerLongLink
  },
  beforeDestroy() {
    this.$socket.disconnect()
    console.log('beforeDestroy APP.vue  this.$socket', this.$socket)
  },
  methods: {
    async init(token) {
      console.log('socketinit', localStorage.getItem('token_customer_stage'))
      const { path } = await api.getSocketPath()

      let version = this.getUrlParams('version')
      let channel = this.getUrlParams('channel')
      socket = io(this.url, {
        // path: '/ws-customer-service/',
        path: path,
        extraHeaders: {
          token: token,
          version: version,
          channel: channel,
        },
      })
      socket.on("disconnect", reason => {
        console.log('disconnect......', reason);
      });
      socket.on("error", (error) => {
        console.log('error', error);
      });
      socket.on("reconnect", attempt => {
        console.log('reconnect', attempt);
      });
      socket.on("reconnect_attempt", reconnect_attempt => {
        console.log('reconnect_attempt', reconnect_attempt);
      });
      socket.on('connect_error', (data) => {
        console.log('created connect_error', data);
      });
      socket.on('connect_timeout', () => {
        console.log('created connect_timeout', socket);
      });


      Vue.prototype.$socket = socket
      console.log('APP.vue socket', socket)
    },
    getUrlParams(params) {
      return this.$route.query[params]
    },
  },
};
</script>


<style>
* {
  margin: 0;
  padding: 0;
}

html {
  width: 100%;
  height: 100%;
  overflow: -moz-scrollbars-none;
}

body {
  width: 100%;
  height: 100%;
}

#app {
  width: 100%;
  height: 100%;
}

img {
  vertical-align: top;
}

::-webkit-scrollbar {
  display: none;
}

/* 组件样式 */
.pickerStyle {
  width: 100%;
}

.mint-cell-wrapper {
  padding: 0 !important;
  background: none !important;
}

.mint-cell {
  border: none !important;
  min-height: auto !important;
}

.mint-field-core {
  line-height: inherit !important;
  border: none !important;
}

input {
  border: none !important;
  background: none !important;
}

.mint-cell:last-child {
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue